// src/App.tsx

import React from 'react';
import './App.css';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import Header from './components/Common/Header';
import SideNav from './components/Common/SideNav';
import Dashboard from './components/Common/DashBoard';
import HelpPage from './components/Common/HelpPage';
import LoginPage from './components/userComponent/LoginPage';
import AuthoringPageCheck from './components/AuthoringComponent/AuthoringPageCheck';
import AuthoringPage from './components/AuthoringComponent/AuthoringPage';
import ComponentDetailView from './components/AuthoringComponent/ComponentDetailView';
import CartPage from './components/AuthoringComponent/CartPage';
import CartCheckoutPage from './components/AuthoringComponent/CartCheckoutPage';
import CartCheckoutConfirmPage from './components/AuthoringComponent/CartCheckoutConfirmPage';
import CartListPage from './components/AuthoringComponent/CartListPage';
import CartDetailPage from './components/AuthoringComponent/CartDetailPage';
import ComponentCardsPage from './components/AuthoringComponent/ComponentCardsPage';
import RequireAuthor from "./components/AuthoringComponent/RequireAuthor";
import RequireAuthenticated from "./components/AuthoringComponent/RequireAuthenticated";
import ReviewPage from './components/AuthoringComponent/ReviewPage';
import VendorsPage from './components/AuthoringComponent/VendorsPage';
import VendorAssemblyMapPage from './components/AuthoringComponent/VendorAssemblyMapPage';
import PartPricing from './components/AuthoringComponent/PartPricing';
import ForgotPassword from './components/userComponent/ForgotPassword';
import Profile from './components/Common/Profile';
import CreateNewPartnumber from './components/AuthoringComponent/CreateNewPartnumber';
import EditPartnumber from './components/AuthoringComponent/EditPartnumber';
import ViewPartnumber from './components/AuthoringComponent/ViewPartnumber';
import CatalogBuilder from './components/AuthoringComponent/CatalogBuilder';
import CreateManual from './components/AuthoringComponent/CreateManual';
import EditManualTitle from './components/AuthoringComponent/EditManualTitle';
import ManualStructurePage from './components/AuthoringComponent/ManualStructurePage';
import ManualStructurePageReviewer from './components/AuthoringComponent/ManualStructurePageReviewer';
import ManualStructurePageVendor from './components/AuthoringComponent/ManualStructurePageVendor';
import TableTemplateBuilder from './components/AuthoringComponent/TableTemplateBuilder';
import PartsSearchPage from './components/AuthoringComponent/PartsSearchPage';

const AppLayout = () => {
  const location = useLocation();
  const isLoginPage = location.pathname === '/' || location.pathname === '/forgot-password' ;
  const isManualStructurePage =
    location.pathname.includes('/authoring/manuals/structure/') ||
    location.pathname.includes('/authoring/manuals/reviewer/') ||
    location.pathname.includes('/authoring/manuals/vendor/');
  const isComponentDetailPage = location.pathname.includes('/component-detail/');
  const isHelpPage = location.pathname === '/help';

  return (
    <div className="App">
      {!isLoginPage && <Header />}
      {/* {!isLoginPage && <SideNav />} */}
      <div
        className="App-content"
        style={
          isLoginPage
            ? { padding: 0 }
            : isManualStructurePage
            ? { paddingTop: 0 }
            : isComponentDetailPage
            ? { paddingTop: 8 }
            : isHelpPage
            ? { paddingTop: 0 }
            : {}
        }
      >
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/help" element={<RequireAuthenticated><HelpPage /></RequireAuthenticated>} />
          <Route path="/authoring" element={<RequireAuthor><AuthoringPageCheck /></RequireAuthor>}/>
          <Route path="/authoring/createpartnumber" element={<RequireAuthor><CreateNewPartnumber /></RequireAuthor>} />
          <Route path="/authoring/edit/:masterAssemblyId" element={<RequireAuthor><EditPartnumber /></RequireAuthor>} />
          <Route path="/authoring/view/:masterAssemblyId" element={<RequireAuthenticated><ViewPartnumber /></RequireAuthenticated>} />
          <Route path="/authoring/catalog/:masterAssemblyId" element={<RequireAuthor><CatalogBuilder /></RequireAuthor>} />
          <Route path="/authoring/manuals/create/:masterAssemblyId" element={<RequireAuthor><CreateManual /></RequireAuthor>} />
          <Route path="/authoring/manuals/edit/:manualId" element={<RequireAuthor><EditManualTitle /></RequireAuthor>} />
          <Route path="/authoring/manuals/structure/:manualId" element={<RequireAuthor><ManualStructurePage /></RequireAuthor>} />
          <Route path="/authoring/manuals/reviewer/:manualId" element={<RequireAuthenticated><ManualStructurePageReviewer /></RequireAuthenticated>} />
          <Route path="/authoring/manuals/vendor/:manualId" element={<RequireAuthenticated><ManualStructurePageVendor /></RequireAuthenticated>} />
          <Route path="/authoring/table-template-builder" element={<RequireAuthor><TableTemplateBuilder /></RequireAuthor>} />
          <Route path="/component-detail/:oem/:masterAssemblyId" element={<ComponentDetailView />} />
          <Route path="/cart" element={<CartListPage />} />
          <Route path="/partprice" element={<PartPricing />} />
          <Route path="/cart/:cartId" element={<CartPage />} />
          <Route path="/cart/:cartId/checkout" element={<CartCheckoutPage />} />
          <Route path="/cart/:cartId/checkout/confirm" element={<CartCheckoutConfirmPage />} />
          <Route path="/cart-detail/:cartId" element={<CartDetailPage />} />
          <Route path="/components" element={<ComponentCardsPage />} />
          <Route path="/search" element={<RequireAuthenticated><PartsSearchPage /></RequireAuthenticated>} />
          <Route path="/review" element={<ReviewPage />} />
          <Route path="/vendors" element={<VendorsPage />} />
          <Route path="/vendor-mapping" element={<VendorAssemblyMapPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/profile" element={<Profile />} />

          {/* Add more routes as needed */}
        </Routes>
      </div>
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AppLayout />
    </BrowserRouter>
  );
}

export default App;
